import React from 'react'
import grid from './gridv2.module.css'

export default props => 
<div className={[grid.container, props.className].join(' ')} style={{
    ...props.style
}}>
   {props.children}
</div>


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Grid/Container.js